var data_selling_plan_id;
var is_data_selling = true;

if ($("#subscription-atc-form").length > 0) {
  data_selling_plan_id = $("#subscription-atc-form")
    .find("input:first-child")
    .attr("data-selling-plan");

  // $('#subscription-atc-form').find('input').click(function(){
  //   if(is_data_selling) {
  //     is_data_selling = false;
  //     $('#subscription-atc-form').find('.add-subscription-to-cart ').prop('disabled', true);
  //   }
  //   else {
  //     is_data_selling = true;
  //     $('#subscription-atc-form').find('.add-subscription-to-cart ').prop('disabled', false);
  //   }
  // });
}
(function ($) {
  $.fn.addSubscriptionToCart = function (button = false) {
    let btn = $(this);
    let id = 0;
    let sellingPlan = 0;

    let form = btn.closest("form");

    let data = form.serializeArray();
    let feeProd = null;

    data.forEach(function (obj) {
      if (obj.name === "id") {
        id = obj.value;
      }

      if(obj.name === "properties[_incFeeProd]") {
        feeProd = obj.value;
      }
    });
    if (button) {
      id = btn.data("id") || $(".add-subscription-to-cart-button").data("id");
    } else if (!id) {
      id = $('[data-form-event] input[name="id"]').val();
    }

    sellingPlan = form.find('input[name="selling_plan"]').val() || btn.attr("data-selling-plan");
    if (!sellingPlan) {
      const subscriptionInput = $("#subscription-atc-form input[data-selling-plan]");
      if (subscriptionInput.length && subscriptionInput.prop("checked")) {
        sellingPlan = subscriptionInput.attr("data-selling-plan");
      } else if ($("[data-form-event] input").prop("checked")) {
        sellingPlan = data_selling_plan_id;
      }
    }

    if (id > 0) {
      let dataAdd = {};
      let lineItem = {
        quantity: 1,
        id: id,
      };

      if (sellingPlan) {
        lineItem.selling_plan = sellingPlan;
      }

      dataAdd = {
        items: [lineItem],
      };

      if( feeProd ) {
        const bundleId = new Date().getTime();
        dataAdd.items[0]["properties"] = {
          "_bundleId": bundleId,
          "_bundleProdId": feeProd
        };
        dataAdd.items.push({
          "quantity": 1,
          "id": feeProd,
          "properties": {
            "_bundleId": bundleId,
            "_isFeeProd": 1
          }
        });
      }

      $.post("/cart/add.js", dataAdd, function () {
        window.location = "/cart";
      });
    }
  };

  function clearCart(callback = false) {
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      data: "",
      dataType: "json",
      success: function () {
        if (typeof callback == "function") {
          callback();
        } else location.reload();
      },
      error: function (XMLHttpRequest, textStatus) {
        /* error code */
      },
    });
    return false;
  }

  function prepWhatYouGetItems() {
    if ($(".section-coaching-what-you-get").length < 1) return;
    let items = $(".section-coaching-what-you-get .item");
    let w = 0;

    items.each(function () {
      let labelW = $(this).find(".label").width();
      if (labelW > w) w = labelW;
    });

    items.each(function () {
      $(this).find(".label").css("min-width", w);
    });
  }

  $(document).on("click", ".add-subscription-to-cart", function (e) {
    e.preventDefault();

    if ($(this).hasClass("disabled")) {
      return false;
    }

    let el = $(this);
    clearCart(function () {
      el.addSubscriptionToCart();
    });
  });

  $(document).on("click", ".add-subscription-to-cart-button", function (e) {
    e.preventDefault();

    if ($(this).hasClass("disabled")) {
      return false;
    }

    let el = $(this);
    clearCart(function () {
      el.addSubscriptionToCart(true);
    });
  });

  $(document).on(
    "change",
    '#subscription-atc-form input[name="id"]',
    function () {
      let el = $(this);
      let btn = el.closest("form").find("button");

      btn.html(btn.attr("data-" + el.attr("id") + "-title"));

      if (el.attr("data-available") === "true") {
        btn.removeAttr("disabled").removeClass("disabled");
      } else {
        btn.attr("disabled", "disabled").addClass("disabled");
      }
    }
  );

  $(function () {
    $("#coaching-what-people-say-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      buttons: true,
      infinite: true,
      nav: true,
      dots: true,
      arrows: true,
      appendArrows: $(".what-people-say__navigation .container"),
      appendDots: $(".what-people-say__navigation .container"),
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
    });

    prepWhatYouGetItems();
  });

  jQuery(window).on("load", function () {
    $(".stories").flickity({
      cellAlign: "left",
      contain: true,
      pageDots: false,
    });

    var customSliderPrevButton = `<button type="button" aria-label="Previous" class="slick-prev red-slider-btn slick-arrow" style=""><span class="icon-arrow-left"></span></button>`;
    var customSliderNextButton = `<button type="button" aria-label="Next" class="slick-next red-slider-btn slick-arrow" style=""><span class="icon-arrow"></span></button>`;

    $(".stories .flickity-button.previous").html(customSliderPrevButton);
    $(".stories .flickity-button.next").html(customSliderNextButton);

    $(".story").css({ height: "100%" });

    $("#coaching-what-people-say-slider_custom").slick({
      infinite: true,
      prevArrow:
        '<button type="button" aria-label="Previous" class="slick-prev red-slider-btn slick-arrow" style=""><span class="icon-arrow-left"></span></button>',
      nextArrow:
        '<button type="button" aria-label="Next" class="slick-next red-slider-btn slick-arrow" style=""><span class="icon-arrow"></span></button>',
      appendArrows: ".coaching-arrows",
      adaptiveHeight: true,
    });

    $(".what-people-say__images-carousel").slick({
      slidesToShow: 3,
      infinite: true,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" aria-label"Previous" class="slick-prev red-slider-btn slick-arrow" style=""><span class="icon-arrow-left"></span></button>',
      nextArrow:
        '<button type="button" aria-label="Next" class="slick-next red-slider-btn slick-arrow" style=""><span class="icon-arrow"></span></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
  const customSlideshows = document.querySelectorAll(
    ".custom-slideshow, .spotlight-carousel-section, .meet-coach-section__slider"
  );

  if (customSlideshows.length === 0) {
    return;
  }

  customSlideshows.forEach(function (slideshow) {
    function replaceArrows() {
      const prevButtons = slideshow.querySelectorAll(
        ".flickity-prev-next-button.previous"
      );
      const nextButtons = slideshow.querySelectorAll(
        ".flickity-prev-next-button.next"
      );

      prevButtons.forEach(function (prevButton) {
        const prevSVG = `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.5 9.49999L0.499984 9.49998M0.499984 9.49998L8.98316 17.9832M0.499984 9.49998L8.98316 1.01681" stroke="currentColor" stroke-linecap="square" stroke-linejoin="bevel"/>
        </svg>`;
        prevButton.innerHTML = prevSVG;
      });

      nextButtons.forEach(function (nextButton) {
        const nextSVG = `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.499977 9.50001L22.5 9.50002M22.5 9.50002L14.0168 1.01684M22.5 9.50002L14.0168 17.9832" stroke="currentColor" stroke-linecap="square" stroke-linejoin="bevel"/>
        </svg>`;
        nextButton.innerHTML = nextSVG;
      });
    }

    replaceArrows();

    slideshow.addEventListener("ready.flickity", function () {
      replaceArrows();
    });

    setTimeout(function () {
      replaceArrows();
    }, 2000);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "childList") {
          const hasFlickityButtons = slideshow.querySelector(
            ".flickity-prev-next-button"
          );
          if (hasFlickityButtons) {
            replaceArrows();
            observer.disconnect();
          }
        }
      });
    });

    observer.observe(slideshow, {
      childList: true,
      subtree: true,
    });
  });
});

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == 'submit') {
    const dataArray = {
      event: 'klaviyo_lead_submit',
      formId: e.detail.formId,
      formVersionId: e.detail.formVersionId,
      email: e.detail.metaData?.$email || undefined,
      phone: e.detail.metaData?.$phone_number || undefined,
      source: e.detail.metaData?.$source || undefined
    }

    // Only for footer form
    if (dataArray.formId == 'STn5rc' && dataArray.email) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataArray);
      console.log('Klaviyo Lead Conversion Tracker Data Layer Push:', dataArray);
    }

    // Only for Mobile form
    if (dataArray.formId == 'WMj7Hz' && dataArray.email) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataArray);
      console.log('Klaviyo Lead Conversion Tracker Data Layer Push:', dataArray);
    }
  }
});

$(".tabs-stage .accordion-tabs").hide();
$(".tabs-stage .accordion-tabs:first").show();
$(".tabs-stage .accordion-tabs:first").addClass("active");
$(".tabs-nav li:first").addClass("tab-active");

// Change tab class and display content
$(".tabs-nav a").on("click", function (event) {
  event.preventDefault();
  $(".tabs-nav li").removeClass("tab-active");
  $(this).parent().addClass("tab-active");
  $(".tabs-stage .accordion-tabs").hide();
  $(".tabs-stage .accordion-tabs").removeClass("active");
  $($(this).attr("href")).show();
  $($(this).attr("href")).addClass("active");
});

$("#faq-search").on("keyup", function () {
  var value = $(this).val();
  var patt = new RegExp(value, "i");

  if (value) {
    $(".tab-header").hide();
    $(".accordion-tabs").show();
  } else {
    $(".tab-header").show();
    $(".accordion-tabs").hide();
    $(".accordion-tabs.active").show();
  }

  $(".accordion-tabs")
    .find(".event-faq-item")
    .each(function () {
      var $accordion = $(this);

      if (
        $accordion.find(".event-faq-a").text().search(patt) >= 0 ||
        $accordion.find(".event-faq-q").text().search(patt) >= 0
      ) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
});

jQuery(document).ready(function ($) {
  $("#klaviyo-flyout-form__step_1_form").on("submit", function (e) {
    e.preventDefault();
    var $form = $(this);
    let stepNum = parseInt($(this).data("step"));

    if (stepNum <= 1) {
      $("#klaviyo-flyout-form__step_2_form-fields").show();
      $(".klaviyo-flyout-form__step_1_form-fields").hide();
      $(".klaviyo-flyout-form__step_1").hide();
      $(".klaviyo-flyout-form__step_2").show();
      $("#klaviyo-flyout-form_btn").text("Continue");
      $(this).data("step", 2);
      return;
    }

    let productId = $form.find('input[name="id"]').val();
    let first_name = $form.find('input[name="first_name"]').val();
    let last_name = $form.find('input[name="last_name"]').val();
    let email = $form.find('input[name="email"]').val();
    let variant_id = $form.find('input[name="variant_id"]').val();
    let quantity = $form.parent().find("#klaviyo-flyout-form__quantity").val();
    if (typeof productId === "undefined" || !productId) {
      console.error("There's no waitlist product defined");
      return;
    }
    let formData = {
      items: [
        {
          id: productId,
          quantity: quantity,
          properties: { _variant_id: variant_id },
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (typeof res.items !== "undefined" && res.items.length > 0) {
          if (typeof first_name !== "undefined") {
            sessionStorage.setItem("customer_first_name", first_name);
          }
          if (typeof last_name !== "undefined") {
            sessionStorage.setItem("customer_last_name", last_name);
          }
          if (typeof email !== "undefined") {
            sessionStorage.setItem("customer_email", email);
          }
          window.location = "/checkout";
        } else {
          $("#klaviyo-flyout-form_error").text(res.description);
          $("#klaviyo-flyout-form_error").show();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });

  $(document).on(
    "click",
    ".template-collection .join-waitlist[data-product-name]",
    function () {
      let prodName = $(this).data("product-name");
      let prodID = $(this).data("product-id");
      let desc = $(this).data("waitlist-desc");

      if (typeof prodName !== "undefined" && prodName) {
        $(".klaviyo-flyout-form__event_name").text(prodName);
      }
      if (typeof desc !== "undefined" && desc) {
        $(".klaviyo-flyout-form__step_2__desc").html(desc);
      }
      if (typeof prodID !== "undefined" && prodID) {
        $(".klaviyo-flyout-form__step_1_form-fields").append(
          `<input type="hidden" name="id" value="${prodID}" />`
        );
      }
    }
  );
  $("a[data-waitlist-desc]").on("click", function () {
    let desc = $(this).data("waitlist-desc");

    if (typeof desc !== "undefined" && desc) {
      $(".klaviyo-flyout-form__step_2__desc").html(desc);
    }
  });

  $("#shopify-section-event-compare-locations-trail")
    .filter(function () {
      return $(this).children().length === 0;
    })
    .hide();

  if (
    document.body.classList.contains("template-product-new-trail") ||
    document.body.classList.contains("template-product-trail-generic") ||
    document.body.classList.contains("template-product-aspen")
  ) {
    var titleElement = document.querySelector(".collection-hero__title");
    var textContent = titleElement.innerHTML;
    textContent = textContent.replace(
      /(TRAIL)/,
      '<span class="highlight">$1</span>'
    );
    titleElement.innerHTML = textContent;
  }
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

const observer = lozad(".lozad-autoplay", {
  loaded: function (el) {
    el.play();
  },
}); // lazy loads elements with default selector as '.lozad'
observer.observe();

/** 
 * Fee product addon
 */
document.addEventListener("DOMContentLoaded", async function () {
  try {
      // Fetch the current cart data
      const response = await fetch('/cart.js');
      const cart = await response.json();
      let cartUpdated = false;

      if (!cart.items || cart.items.length === 0) {
          return;
      }

      const bundleGroups = {};
      const itemsToAdd = [];
      const itemsToRemove = [];

      // Step 1: Organize items by _bundleId
      cart.items.forEach((item, index) => {
          if (item.properties && item.properties._bundleId) {
              const bundleId = item.properties._bundleId;

              if (!bundleGroups[bundleId]) {
                  bundleGroups[bundleId] = [];
              }
              bundleGroups[bundleId].push({ ...item, line: index + 1 });
          }
      });

      // Step 2: Loop through items to check for missing bundle products or orphaned fee products
      cart.items.forEach((item, index) => {
          if (!item.properties) return;

          const bundleId = item.properties._bundleId;

          // If an item has _bundleProdId but no matching _bundleId items, add feee product
          if (item.properties._bundleProdId && (!bundleGroups[bundleId] || bundleGroups[bundleId].length === 1)) {
              itemsToAdd.push(item.properties._bundleProdId);
          }

          // If an item has _isFeeProd and no matching _bundleId items, remove fee product
          if (item.properties._isFeeProd && (!bundleGroups[bundleId] || bundleGroups[bundleId].length === 1)) {
              itemsToRemove.push(item.key); // Shopify uses 1-based index for line items
          }
      });

      // Step 3: Add missing bundle products
      if (itemsToAdd.length > 0) {
          await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: itemsToAdd.map(id => ({ id, quantity: 1 })) })
          });
          cartUpdated = true;
      }

      // Step 4: Remove orphaned fee products
      if (itemsToRemove.length > 0) {
          const updates = {};
          itemsToRemove.forEach(line => updates[line] = 0);

          await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
          });
          cartUpdated = true;
      }

      if (cartUpdated) {
        window.location.reload();
      }

  } catch (error) {
      console.error("Error managing Shopify cart:", error);
  }
});


// Find  fee product bundle
async function getBundleItems(bundleId) {
  try {
      // Fetch Shopify cart data
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Ensure cart items exist
      if (!cart.items || cart.items.length === 0) {
          return [];
      }
      // Loop through cart items and find matching _bundleId
      const result = cart.items
          .map((item, index) => ({
              index: index + 1 ,
              line: item.key,
              quantity: item.quantity
          }))
          .filter(item => cart.items[item.index - 1].properties && cart.items[item.index - 1].properties._bundleId == bundleId);

      return result;
  } catch (error) {
      console.error('Error fetching cart data:', error);
      return [];
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelectorAll(".event-submission-container").length > 0) {
    const submissionContainers = document.querySelectorAll(
      ".event-submission-container"
    );
    const wrapper = document.createElement("div");
    wrapper.classList.add("event-submission-wrapper");
    submissionContainers.forEach((container) => {
      wrapper.appendChild(container);
    });
    document.body.appendChild(wrapper);
    if (document.querySelector(".section-countdown")) {
      const sectionCountdown = document.querySelector(".section-countdown");
      sectionCountdown.insertAdjacentElement("afterend", wrapper);
    }
  }

  if (document.querySelectorAll(".event-details-container").length > 0) {
    const submissionContainers = document.querySelectorAll(
      ".event-details-container"
    );
    const wrapper = document.createElement("div");
    wrapper.classList.add("event-details-wrapper");
    submissionContainers.forEach((container) => {
      wrapper.appendChild(container);
    });
    document.body.appendChild(wrapper);
    if (document.querySelector(".section-image-and-text")) {
      const sectionImageAndText = document.querySelector(
        ".section-image-and-text"
      );
      sectionImageAndText.prepend(wrapper);
    }
  }

  if (document.querySelector("[data-lottery-element]")) {
    const lotteryButtons = document.querySelectorAll("[data-lottery-button]");

    lotteryButtons.forEach(function (lotteryButton) {
      lotteryButton.addEventListener("click", (event) => {
        lotteryButtons.forEach((button) => {
          button.classList.remove("active-aspen-button");
        });

        lotteryButton.classList.add("active-aspen-button");

        let variantId = lotteryButton.getAttribute("data-variant-id");
        let sellingPlanId = lotteryButton.getAttribute("data-selling-plan-id");
        let entryName = lotteryButton.getAttribute("data-name");

        let variantIdInput = document.querySelector(
          '[data-form-event] input[name="id"]'
        );
        let sellingPlanInput = document.querySelector(
          '[data-form-event] input[name="selling_plan"]'
        );
        let entryNameInput = document.querySelector(
          "[data-form-event] [data-entry-input]"
        );

        variantIdInput.value = variantId;
        entryNameInput.value = entryName;

        if (sellingPlanId != null) {
          sellingPlanInput.value = sellingPlanId;
        } else {
          sellingPlanInput.value = "";
        }

        document
          .querySelector('.btn--aspen-product[type="submit"]')
          .removeAttribute("disabled");
      });
    });

    // document.querySelector('.btn--aspen-product[type="submit"]').addEventListener('click', (event) => {
    //   console.log('button clicked');
    //   let sellingPlanInput = document.querySelector('[data-form-event] input[name="selling_plan"]');
    //   if (sellingPlanInput.value === '') {
    //     event.preventDefault();
    //     const errorMessage = document.createElement('p');
    //     errorMessage.textContent = 'Please choose an option';
    //     errorMessage.style.color = 'red';
    //     errorMessage.style.marginTop = '10px';

    //     // Remove any existing error message first
    //     const existingError = document.querySelector('.lottery-error-message');
    //     if (existingError) {
    //       existingError.remove();
    //     }

    //     errorMessage.classList.add('lottery-error-message');
    //     event.target.parentNode.appendChild(errorMessage);
    //     return;
    //   }
    // });
  }

  // Custom JS to close/open mobile nav
  const mobileNavClose = document.querySelector("[data-mobile-nav-close]");
  const mobileNavOpen = document.querySelector("[data-mobile-nav-open]");
  const mobileNav = document.querySelector(".mobile-nav-wrapper");

  mobileNavOpen.addEventListener("click", () => {
    mobileNav.classList.add("js-menu--is-open");
  });

  mobileNavClose.addEventListener("click", () => {
    mobileNav.classList.remove("js-menu--is-open");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let flkty = null;
  const spotlightCarousels = document.querySelectorAll(
    ".spotlight-carousel-section .js-spotlight-carousel-slider, .meet-coach-section__slider, [data-slider-container]"
  );

  spotlightCarousels.forEach(function (carousel) {
    // Initialize Flickity
    if (document.querySelector('[data-slider-container]')) {
      if (window.innerWidth >= 1024) {
        flkty = new Flickity(carousel, {
          cellAlign: "center",
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: false,
          cellGap: 24,
          fade: true,
          adaptiveHeight: true,
          groupCells: 2
        });
      }
    } else {
      flkty = new Flickity(carousel, {
        cellAlign: "center",
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        cellGap: 24,
        fade: true,
        adaptiveHeight: true
      });
    }

    // Get all navigation buttons for this carousel
    const container = carousel.closest(".spotlight-carousel__container, .meet-coach-section__slider-wrapper, [data-slider]");
    const prevButtons = container.querySelectorAll(
      ".spotlight-carousel__nav-button--prev"
    );
    const nextButtons = container.querySelectorAll(
      ".spotlight-carousel__nav-button--next"
    );

    // Add click handlers for previous buttons
    prevButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        flkty.previous();
      });
    });

    // Add click handlers for next buttons
    nextButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        flkty.next();
      });
    });

    // Update button states based on Flickity's state
    function updateButtonStates() {
      const isFirst = flkty.selectedIndex === 0;
      const isLast = flkty.selectedIndex === flkty.slides.length - 1;

      prevButtons.forEach(function (button) {
        button.disabled = isFirst;
        button.style.opacity = isFirst ? "0.5" : "1";
      });

      nextButtons.forEach(function (button) {
        button.disabled = isLast;
        button.style.opacity = isLast ? "0.5" : "1";
      });
    }

    // Update button states on init and change
    flkty.on("select", updateButtonStates);
    updateButtonStates();
  });
});

// Hero Banner Parallax Effect
document.addEventListener("DOMContentLoaded", () => {
  const parallaxContainer = document.querySelector(
    ".hero-banner__overlay--black"
  );

  if (!parallaxContainer) {
    return;
  }

  const parallaxElements = parallaxContainer.querySelectorAll(
    ".hero-banner__overlay-bar"
  );

  if (parallaxElements.length === 0) {
    return;
  }

  // Different directions and speeds for each bar to create separation effect
  const barConfigs = [
    { direction: -1, speed: 2 },
    { direction: 1, speed: 2 },
    { direction: -1, speed: 2 },
    { direction: 1, speed: 2 },
    { direction: -1, speed: 2 },
  ];

  window.addEventListener("scroll", () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const animationEnd = windowHeight / 1.5;
    const scrollProgress = Math.max(0, Math.min(1, scrollY / animationEnd));

    // Bars stay fixed but move apart to reveal background
    parallaxElements.forEach((el, i) => {
      const config = barConfigs[i] || { direction: 1, speed: 1 };
      const maxDistance = windowHeight * 1.2;
      const y = scrollProgress * maxDistance * config.direction * config.speed;
      el.style.transform = `translateY(${y}px)`;

      // Gradually reduce opacity as bars move apart
      const opacity = 1 - scrollProgress;
      el.style.opacity = opacity;

      if (document.querySelector(".hero-banner__video")) {
        const videoElement = document.querySelector(".hero-banner__video");
        if (opacity <= 0.58) {
          videoElement.play();
        } else {
          videoElement.pause();
        }
      }

    });

    // Hide bars when animation is complete
    if (scrollProgress >= 1) {
      parallaxContainer.style.opacity = "0";
      parallaxContainer.style.pointerEvents = "none";
    } else {
      parallaxContainer.style.opacity = "1";
      parallaxContainer.style.pointerEvents = "auto";
    }
  });
});

const main = document.querySelector("main");
const heroBannerExists = document.querySelector(".hero-banner");

if (heroBannerExists) {
  const shopifySections = main.querySelectorAll('[id^="shopify-section"]');
  const footer = document.querySelector("#shopify-section-footer");
  shopifySections.forEach((section) => {
    section.style.zIndex = "1";
    section.style.position = "relative";
  });
  footer.style.zIndex = "1";
  footer.style.position = "relative";
}

// Initialize showcase grid sliders on mobile
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('[data-showcase-slider]')) {
    const showcaseSliders = document.querySelectorAll('[data-showcase-slider]');

    showcaseSliders.forEach(function (showcaseSlider) {
      const useSlider = showcaseSlider.getAttribute('data-use-slider');

      if (useSlider === "true") {
        // Only initialize on mobile devices
        if (window.innerWidth <= 767) {
          const flkty = new Flickity(showcaseSlider, {
            cellAlign: "center",
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            wrapAround: false,
            cellGap: 24,
            fade: true,
            adaptiveHeight: true,
          });

          // Get all navigation buttons for this carousel
          const container = showcaseSlider;
          const prevButtons = container.querySelectorAll(
            ".spotlight-carousel__nav-button--prev"
          );
          const nextButtons = container.querySelectorAll(
            ".spotlight-carousel__nav-button--next"
          );

          // Add click handlers for previous buttons
          prevButtons.forEach(function (button) {
            button.addEventListener("click", function (e) {
              e.preventDefault();
              flkty.previous();
            });
          });

          // Add click handlers for next buttons
          nextButtons.forEach(function (button) {
            button.addEventListener("click", function (e) {
              e.preventDefault();
              flkty.next();
            });
          });

          // Update button states based on Flickity's state
          function updateButtonStates() {
            const isFirst = flkty.selectedIndex === 0;
            const isLast = flkty.selectedIndex === flkty.slides.length - 1;
      
            prevButtons.forEach(function (button) {
              button.disabled = isFirst;
              button.style.opacity = isFirst ? "0.5" : "1";
            });
      
            nextButtons.forEach(function (button) {
              button.disabled = isLast;
              button.style.opacity = isLast ? "0.5" : "1";
            });
          }
      
          // Update button states on init and change
          flkty.on("select", updateButtonStates);
          updateButtonStates();
        }
      }
    });
  }
});

// Custom Video Section Play/Pause Logic
function handleCustomVideoPlayPause(e) {
  var btn = e.target.closest('[data-custom-video-playpause]');
  if (!btn) return;
  var section = btn.closest('.custom-video-section-container');
  if (!section) return;
  var video = section.querySelector('.custom-video-element');
  if (!video) return;
  var playIcon = btn.querySelector('.custom-video-icon--play');
  var pauseIcon = btn.querySelector('.custom-video-icon--pause');
  if (video.paused) {
    video.play();
    if (playIcon) playIcon.style.display = 'none';
    if (pauseIcon) pauseIcon.style.display = '';
  } else {
    video.pause();
    if (playIcon) playIcon.style.display = '';
    if (pauseIcon) pauseIcon.style.display = 'none';
  }
}

document.addEventListener('click', function(e) {
  if (e.target.closest('[data-custom-video-playpause]')) {
    handleCustomVideoPlayPause(e);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.custom-video-section-container').forEach(function(section) {
    var video = section.querySelector('.custom-video-element');
    var btn = section.querySelector('[data-custom-video-playpause]');
    if (!video || !btn) return;
    var playIcon = btn.querySelector('.custom-video-icon--play');
    var pauseIcon = btn.querySelector('.custom-video-icon--pause');
    video.addEventListener('play', function() {
      if (playIcon) playIcon.style.display = 'none';
      if (pauseIcon) pauseIcon.style.display = '';
    });
    video.addEventListener('pause', function() {
      if (playIcon) playIcon.style.display = '';
      if (pauseIcon) pauseIcon.style.display = 'none';
    });
  });
});

// Hero Banner Video Scroll Visibility
function handleHeroVideoVisibility() {
  const heroVideo = document.querySelector('.hero-banner--video');

  if (!heroVideo) {
    return;
  }

  const rect = heroVideo.getBoundingClientRect();
  const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

  if (isVisible) {
    heroVideo.style.opacity = '1';
  } else {
    heroVideo.style.opacity = '0';
  }

  heroVideo.style.setProperty('opacity', isVisible ? '1' : '0', 'important');
}

document.addEventListener('DOMContentLoaded', function() {
  handleHeroVideoVisibility();
  window.addEventListener('scroll', handleHeroVideoVisibility);
});

// Variants Modal Functionality
document.addEventListener('DOMContentLoaded', function() {
  if (!document.getElementById('variants-modal')) {
    return;
  }

  const modal = document.getElementById('variants-modal');
  const openButton = document.querySelector('[data-open-variants-modal]');
  const closeButton = document.querySelector('[data-close-modal]');
  const overlay = document.querySelector('.variants-modal__overlay');
  const options = document.querySelectorAll('.variants-modal__option');
  const form = document.querySelector('.variants-modal__form');
  const variantIdInput = document.getElementById('variant-id-input');
  const quantityInput = document.getElementById('variant-quantity-input');
  const sellingPlanInput = document.getElementById('variant-selling-plan-input');

  // Open modal
  if (openButton) {
    openButton.addEventListener('click', function(e) {
      e.preventDefault();
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      // Set initial values from first option
      if (options.length > 0) {
        const firstOption = options[0];
        variantIdInput.value = firstOption.dataset.variantId || '';
        sellingPlanInput.value = firstOption.dataset.sellingPlanId || '';
        quantityInput.value = '1';
      }
    });
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }

  // Close modal on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });

  options.forEach(function(option) {
    option.addEventListener('click', function() {
      options.forEach(function(opt) {
        opt.classList.remove('variants-modal__option--selected');
      });

      this.classList.add('variants-modal__option--selected');

      variantIdInput.value = this.dataset.variantId || '';
      sellingPlanInput.value = this.dataset.sellingPlanId || '';
      quantityInput.value = '1';
    });
  });

  // Handle form submission
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      if (!variantIdInput.value) {
        return;
      }

      // Prepare form data
      const formData = new FormData();
      formData.append('id', variantIdInput.value);
      formData.append('quantity', quantityInput.value);

      if (sellingPlanInput.value) {
        formData.append('selling_plan', sellingPlanInput.value);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          console.log('Error: ' + data.description);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(error => {
        console.error('Error:', error);
        console.log('An error occurred while adding to cart');
      });
    });
  }
});